<template>
  <div class="alert alert-dismissible fade show m-alert m-alert--air" :class="alertType" role="alert">
    <button id="btn-close-alert" type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
    {{ body }}
  </div>  
</template>

<script>
export default {
  props: {
    body: { required: false, type: String },
    alertType: { required: true, type: String }
  }
}
</script>

<style>

</style>





// WEBPACK FOOTER //
// Alert.vue